// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3s0zl","black":"black__3B0NW","name":"name__3yn0I","index":"index__rG2z5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/styles.scss
// module id = 153
// module chunks = 0